/** A bot is near its stop-loss when equity is within this fraction of the stop-loss level. */
export const NEAR_STOP_LOSS_RATIO = 0.1;

interface StopLossStats {
  equity?: number | string | null;
  stopLoss?: number | string | null;
}

/** Distance from equity down to the stop-loss level, as a fraction of equity; null when no stop-loss is set. */
export const stopLossDistance = (stats: StopLossStats | null | undefined): number | null => {
  const equity = Number(stats?.equity);
  const stopLoss = Number(stats?.stopLoss);
  if (!Number.isFinite(equity) || !Number.isFinite(stopLoss) || stopLoss <= 0 || equity <= 0) return null;
  return (equity - stopLoss) / equity;
};

export const isNearStopLoss = (stats: StopLossStats | null | undefined): boolean => {
  const distance = stopLossDistance(stats);
  return distance !== null && distance <= NEAR_STOP_LOSS_RATIO;
};
